import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from "@angular/common";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ChangeDetectionStrategy, Component, computed, ElementRef, EventEmitter, input, Input, Output, signal, ViewChild, WritableSignal, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { HeaderOption, PromptHeader } from '@k12/models';

@Component({
  // changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    TextFieldModule
  ],
  selector: 'app-header-instructions',
  styleUrl: './header-instructions.component.scss',
  templateUrl: './header-instructions.component.html'
})
export class HeaderInstructionsComponent implements OnInit {
  @ViewChild('headerInput') headerInput: ElementRef;
  @ViewChild('instructionsInput') instructionsInput: ElementRef;

  @Input() set hideHeader(value: boolean | undefined) {
    this.isHideHeader.set(value);
  }
  @Input() set hideInstructions(value: boolean | undefined) {
    this.isHideInstructions.set(value);
  }
  @Input() set promptHeader(value: string | undefined) {
    this.headerValue.set(value);
  }
  @Input() set promptInstructions(value: string | undefined) {
    this.instructionValue.set(value);
  }
  @Input() set alwaysEditable(value: boolean) {
    this.isAlwaysEditable.set(value ?? false);
  }
  @Input() set preview(value: boolean) {
    this.isPreview.set(value);
  }

  @Input() set headerPlaceHolder(value: string | undefined) {
    this.headerPlaceHolderValue.set(value);
  }
  @Input() set instructionPlaceHolder(value: string | undefined) {
    this.instructionPlaceHolderValue.set(value);
  }
  @Output() headerInstructionValues = new EventEmitter<PromptHeader>();

  public editHeaderOptions = input<boolean>();
  public headerValue: WritableSignal<string | undefined> = signal(undefined);
  public instructionValue: WritableSignal<string | undefined> = signal(undefined);
  public isEditHeader: WritableSignal<boolean> = signal(false);
  public isAlwaysEditable: WritableSignal<boolean> = signal(false);
  public isEditInstructions: WritableSignal<boolean> = signal(false);
  public isHideHeader = signal<boolean | undefined>(undefined);
  public isHideInstructions = signal<boolean | undefined>(undefined);
  public headerPlaceHolderValue = signal<string | undefined>(undefined);
  public instructionPlaceHolderValue = signal<string | undefined>(undefined);
  public isPreview = signal<boolean>(false);
  public isPromptHeader = input<boolean>();
  public showHeader;
  public showInstructions;

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  public ngOnInit(): void {
    this.showHeader = computed(() => (!this.isPreview() || (this.isValidString(this.headerValue()) && !this.isHideHeader())) || (!this.isPreview() && (!this.isHideHeader() && !this.editHeaderOptions()) || this.editHeaderOptions()));
    this.showInstructions = computed(() => (!this.isPreview() || (this.isValidString(this.instructionValue()) && !this.isHideInstructions())) || (!this.isPreview() && (!this.isHideInstructions() && !this.editHeaderOptions()) || this.editHeaderOptions()));
    this.isEditHeader.set(this.isAlwaysEditable());
    this.isEditInstructions.set(this.isAlwaysEditable());
  }

  public onFocusOutInput(): void {
    this.isEditHeader.set(this.isAlwaysEditable());
    this.isEditInstructions.set(this.isAlwaysEditable());
  }

  public onInputChange(): void {
    setTimeout(() => {
      this.emitValues();
    }, 1); // Timeout used to prevent race condition
  }

  public onSelectPromptMenu(option?: HeaderOption): void {
    if (option === HeaderOption.Header) {
      this.isEditHeader.set(true);
      this.headerInput.nativeElement.focus();
    } else {
      this.isEditInstructions.set(true);
      this.instructionsInput.nativeElement.focus();
    }
  }

  public hideHeaderOrInstructions(isHeader?: boolean): void {
    if (isHeader) {
      this.isHideHeader.set(!this.isHideHeader());
    } else {
      this.isHideInstructions.set(!this.isHideInstructions());
    }
    this.emitValues();
  }

  get promptHeader(): (string | undefined) {
    return this.headerValue();
  }

  get promptInstructions(): (string | undefined) {
    return this.instructionValue();
  }

  get hasHeaderPlaceHolder(): boolean {
    return this.isValidString(this.headerPlaceHolderValue());
  }

  get hasInstructionPlaceHolder(): boolean {
    return this.isValidString(this.instructionPlaceHolderValue());
  }

  private emitValues(): void {
    if (this.isEmptyString(this.headerValue())) {
      this.headerValue.set(undefined);
    }

    if (this.isEmptyString(this.instructionValue())) {
      this.instructionValue.set(undefined);
    }

    this.headerInstructionValues.emit({
      header: this.headerValue(),
      hideHeader: this.isHideHeader(),
      instructions: this.instructionValue(),
      hideInstructions: this.isHideInstructions()
    });
  }

  private isEmptyString(value: string | undefined): boolean {
    return (typeof value === 'string' && value.trim().length === 0)
  }

  private isValidString(value: string | undefined): boolean {
    return (typeof value === 'string' && value.trim().length > 0);
  }
}